module.exports = __webpack_public_path__ + "img/hzhlwfy_logo_img.118489e9.png";